
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

const AVAILABLE_PERMISSIONS = [
  { id: 'manage_students', label: 'Manage Students', description: 'Add, edit, and delete student records' },
  { id: 'manage_teachers', label: 'Manage Teachers', description: 'Add, edit, and delete teacher records' },
  { id: 'manage_admins', label: 'Manage Admins', description: 'Add, edit, and delete admin accounts' },
  { id: 'view_reports', label: 'View Reports', description: 'Access and view system reports' },
  { id: 'manage_timetable', label: 'Manage Timetable', description: 'Create and modify class schedules' },
  { id: 'manage_payments', label: 'Manage Payments', description: 'Process and track payments' },
  { id: 'system_settings', label: 'System Settings', description: 'Access system configuration' },
  { id: 'backup_restore', label: 'Backup & Restore', description: 'Perform data backup and restore operations' }
];

const AdminPermissionsSection = () => {
  const { watch, setValue } = useFormContext();
  const permissions = watch('permissions') || [];

  const handlePermissionChange = (permissionId: string, checked: boolean) => {
    let updatedPermissions = [...permissions];
    
    if (checked) {
      if (!updatedPermissions.includes(permissionId)) {
        updatedPermissions.push(permissionId);
      }
    } else {
      updatedPermissions = updatedPermissions.filter(p => p !== permissionId);
    }
    
    setValue('permissions', updatedPermissions);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Permissions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {AVAILABLE_PERMISSIONS.map((permission) => (
            <div key={permission.id} className="flex items-start space-x-3 p-3 border rounded-md">
              <Checkbox
                id={permission.id}
                checked={permissions.includes(permission.id)}
                onCheckedChange={(checked) => handlePermissionChange(permission.id, !!checked)}
              />
              <div className="grid gap-1.5 leading-none">
                <Label htmlFor={permission.id} className="font-medium">
                  {permission.label}
                </Label>
                <p className="text-xs text-muted-foreground">
                  {permission.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminPermissionsSection;
